export default (browserLang, languages) => {
  let langName;
  Object.values(languages).forEach(lang => {
    if (lang.code.includes(browserLang)) {
      langName = lang.name;
    }
  });
  return langName ? langName : languages.pl.name;
};
